import { render, staticRenderFns } from "./ApfBasicInput.vue?vue&type=template&id=146d7440&scoped=true"
import script from "./ApfBasicInput.vue?vue&type=script&lang=js"
export * from "./ApfBasicInput.vue?vue&type=script&lang=js"
import style0 from "./ApfBasicInput.vue?vue&type=style&index=0&id=146d7440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d7440",
  null
  
)

export default component.exports